import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["className", "children", "htmlFor", "inverse", "helpMessage", "helpLabel", "helpAriaLabel", "hint", "optional", "optionalIndicatorText", "required", "requiredIndicatorText", "isFieldSetLegend"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { uniqueIdForComponent } from '../../../util';
import { HelpMessage, HelpButton } from '../../..';
var propTypes = {
  /** styling class */
  className: PropTypes.string,
  /** node for the label as a child */
  children: PropTypes.node.isRequired,
  /**
   * the form control (input, textarea etc) id that the label is referencing.
   */
  htmlFor: PropTypes.string,
  /** specifies if optional text should also be shown */
  optional: PropTypes.bool,
  /** text to display when optional prop is true */
  optionalIndicatorText: PropTypes.string,
  /** specifies if required text should also be shown */
  required: PropTypes.bool,
  /** text to display when required prop is true */
  requiredIndicatorText: PropTypes.string,
  /**  bool value to indicate if the field is the inverse style */
  inverse: PropTypes.bool,
  /**  hint text */
  hint: PropTypes.node,
  /** Node to be used as the help message */
  helpMessage: PropTypes.node,
  /** help toggle button label */
  helpLabel: PropTypes.string,
  /** used by screen readers to describe the help toggle button */
  helpAriaLabel: PropTypes.string,
  /** specifies if the label is used as the FieldSet legend.   */
  isFieldSetLegend: PropTypes.bool
};
var defaultProps = {
  className: undefined,
  helpMessage: undefined,
  helpLabel: 'Help',
  helpAriaLabel: 'Help',
  hint: undefined,
  htmlFor: undefined,
  inverse: false,
  optional: false,
  optionalIndicatorText: 'Optional',
  required: false,
  requiredIndicatorText: 'Required',
  isFieldSetLegend: false
};
var Label = function Label(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    helpExpanded = _useState2[0],
    setHelpExpanded = _useState2[1];
  var className = props.className,
    children = props.children,
    htmlFor = props.htmlFor,
    inverse = props.inverse,
    helpMessage = props.helpMessage,
    helpLabel = props.helpLabel,
    helpAriaLabel = props.helpAriaLabel,
    hint = props.hint,
    optional = props.optional,
    optionalIndicatorText = props.optionalIndicatorText,
    required = props.required,
    requiredIndicatorText = props.requiredIndicatorText,
    isFieldSetLegend = props.isFieldSetLegend,
    otherProps = _objectWithoutProperties(props, _excluded);
  var fieldLabelGroupClass = classnames('wds-c-field-label-group', {
    'wds-c-legend': isFieldSetLegend,
    'wds-c-field-label-group--with-hint': hint !== undefined
  });
  var fieldHintClass = classnames('wds-c-field-hint', {
    'wds-c-field-hint--inverse': inverse
  });
  var stylingClass = classnames('wds-c-field-label', className);
  var optionalIndicator = /*#__PURE__*/React.createElement("span", {
    className: "wds-c-form__required-indicator"
  }, optionalIndicatorText);
  var requiredIndicator = /*#__PURE__*/React.createElement("span", {
    className: "wds-c-form__required-indicator"
  }, requiredIndicatorText);
  var hintElement = /*#__PURE__*/React.createElement("p", _extends({}, htmlFor && {
    id: "".concat(htmlFor, "-hint")
  }, {
    className: fieldHintClass
  }), hint);
  var helpAlertId = uniqueIdForComponent();
  var helpButton = /*#__PURE__*/React.createElement(HelpButton, {
    label: helpLabel,
    ariaLabel: helpAriaLabel,
    toggleId: helpAlertId,
    ariaDescribedById: helpAlertId,
    expanded: helpExpanded,
    onClick: function onClick() {
      return setHelpExpanded(!helpExpanded);
    }
  });
  var helpMessageAlert = /*#__PURE__*/React.createElement(HelpMessage, {
    className: "wds-u-mb--small",
    id: helpAlertId,
    text: helpMessage,
    expanded: helpExpanded
  });
  var FieldGroupTag = isFieldSetLegend ? 'legend' : 'div';
  var Tag = isFieldSetLegend ? 'span' : 'label';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldGroupTag, {
    className: fieldLabelGroupClass
  }, /*#__PURE__*/React.createElement(Tag, _extends({}, htmlFor && !isFieldSetLegend && {
    id: "".concat(htmlFor, "-label")
  }, !isFieldSetLegend && {
    htmlFor: htmlFor
  }, {
    className: stylingClass
  }, otherProps), children, required && requiredIndicator && requiredIndicator, optional && optionalIndicator && optionalIndicator, hint && hintElement), helpMessage && !isFieldSetLegend && helpButton), helpMessage && isFieldSetLegend && helpButton, helpMessage && helpMessageAlert);
};
Label.propTypes = propTypes;
Label.defaultProps = defaultProps;
export default Label;